function syncCrestlaneQuantity(input) {
  const form = input.closest('form');
  const switchingVariant = form?.dataset.clVariantLoading === 'true';
  const min = Number(input.min || 0), max = input.max === '' ? Infinity : Number(input.max);
  const step = Number(input.step || 1), value = Number(input.value) || min;
  input.closest('.cl-quantity')?.querySelectorAll('[data-cl-step]').forEach(button => {
    button.disabled = switchingVariant || input.disabled || (Number(button.dataset.clStep) < 0 ? value <= min : value + step > max);
  });
  const four = form?.querySelector('[data-cl-add-four]');
  if (four) four.disabled = switchingVariant || input.disabled || min > 4 || max < 4 || (4 - min) % step !== 0 || value === 4;
  const purchase = input.closest('[data-cl-purchase]');
  if (!purchase) return;
  const available = purchase.dataset.stockAvailable === 'true';
  const canAdd = available && !switchingVariant && !input.disabled && value >= min && value <= max && input.validity.valid;
  const submitting = form.dataset.clSubmitting === 'true';
  const button = form.querySelector('[name="add"]');
  if (button) button.disabled = !canAdd || submitting;
  const total = new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: purchase.dataset.currency, currencyDisplay: 'narrowSymbol'
  }).format(Number(purchase.dataset.unitPrice) * value / 100) + ' ' + purchase.dataset.currency;
  const label = purchase.dataset.addLabel.replace('__QTY__', String(value)).replace('__TOTAL__', total);
  if (available) purchase.querySelector('[data-cl-add-text]').textContent = label;
  const notice = purchase.querySelector('[data-cl-limit-note]');
  if (notice) notice.hidden = !available || max >= min;
  if (form.getAttribute('id') === 'CrestlaneProductForm') {
    const sticky = document.querySelector('[data-cl-sticky-purchase]');
    if (sticky) {
      sticky.querySelector('[data-cl-sticky-text]').textContent = label;
      sticky.querySelector('button').disabled = !canAdd || submitting;
    }
  }
}
function syncCrestlaneCartLimits(content) {
  const data = content?.querySelector('[data-cl-cart-quantities]');
  if (!data) return;
  let quantities;
  try { quantities = JSON.parse(data.textContent); } catch { return; }
  document.querySelectorAll('[data-cl-purchase]').forEach(purchase => {
    const input = purchase.querySelector('[name="quantity"]');
    const limit = purchase.dataset.limit === '' ? Infinity : Number(purchase.dataset.limit);
    const inCart = quantities.reduce((sum, item) => sum + (String(item.id) === purchase.dataset.variantId ? item.quantity : 0), 0);
    const remaining = Math.max(0, limit - inCart);
    if (Number.isFinite(remaining)) input.max = String(remaining);
    const min = Number(input.min || 1), step = Number(input.step || 1);
    input.disabled = purchase.dataset.stockAvailable !== 'true' || remaining < min;
    if (!input.disabled && Number(input.value) > remaining) input.value = String(min + Math.floor((remaining - min) / step) * step);
    syncCrestlaneQuantity(input);
  });
}
const crestlaneVariantRequests = new WeakMap();
async function updateCrestlaneVariant(select) {
  const form = select.form;
  const root = select.closest('[data-cl-product-section]');
  const section = root?.closest('.shopify-section');
  if (!form || !root || !section) return;
  if (form.dataset.clSubmitting === 'true') {
    select.value = root.dataset.clVariantId;
    return;
  }
  const variantId = select.value;
  crestlaneVariantRequests.get(select)?.abort();
  const controller = new AbortController();
  crestlaneVariantRequests.set(select, controller);
  const status = form.querySelector('[data-cl-variant-status]');
  form.dataset.clVariantLoading = 'true';
  form.setAttribute('aria-busy', 'true');
  status.classList.add('cl-sr');
  status.textContent = status.dataset.loading;
  form.querySelectorAll('.cl-quantity input').forEach(syncCrestlaneQuantity);
  const url = new URL(window.location.href);
  url.searchParams.set('variant', variantId);
  const requestUrl = new URL(url);
  requestUrl.searchParams.set('section_id', root.dataset.clProductSection);
  try {
    const response = await fetch(requestUrl, {
      signal: controller.signal, cache: 'no-store', headers: { Accept: 'text/html' }
    });
    if (!response.ok) throw new Error('Variant section unavailable');
    const html = await response.text();
    if (controller.signal.aborted || crestlaneVariantRequests.get(select) !== controller || !select.isConnected) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const nextRoot = parsed.querySelector('[data-cl-product-section]');
    if (nextRoot?.dataset.clVariantId !== variantId || nextRoot.dataset.clProductSection !== root.dataset.clProductSection) throw new Error('Variant section mismatch');
    const regions = ['[data-cl-variant-price]', '[data-cl-variant-stock]', '[data-cl-purchase]', '[data-cl-variant-sku]'].map(selector => ({
      current: root.querySelector(selector), next: nextRoot.querySelector(selector)
    }));
    const currentImage = root.querySelector('[data-cl-variant-image]');
    const nextImage = nextRoot.querySelector('[data-cl-variant-image]');
    const nextSelect = nextRoot.querySelector('[data-cl-variant]');
    if (regions.some(region => !region.current || !region.next) || !currentImage || !nextImage || !nextSelect) throw new Error('Variant details missing');
    const desiredQuantity = Number(form.querySelector('[name="quantity"]').value) || 1;
    regions.forEach(region => region.current.replaceWith(region.next));
    Array.from(select.options).forEach(option => {
      const nextOption = Array.from(nextSelect.options).find(item => item.value === option.value);
      if (nextOption) option.textContent = nextOption.textContent;
    });
    const previousImage = currentImage.querySelector('img');
    const selectedImage = nextImage.querySelector('img');
    if (previousImage?.getAttribute('src') !== selectedImage?.getAttribute('src') || previousImage?.getAttribute('srcset') !== selectedImage?.getAttribute('srcset')) {
      currentImage.replaceChildren(...nextImage.childNodes);
    }
    const sticky = section.querySelector('[data-cl-sticky-purchase]');
    const nextSticky = parsed.querySelector('[data-cl-sticky-purchase]');
    if (sticky && nextSticky) sticky.replaceWith(nextSticky);
    else if (sticky) sticky.remove();
    else if (nextSticky) section.append(nextSticky);
    root.dataset.clVariantId = variantId;
    const quantity = form.querySelector('[name="quantity"]');
    const min = Number(quantity.min || 1), step = Number(quantity.step || 1);
    const max = quantity.max === '' ? Infinity : Number(quantity.max);
    const requested = min + Math.max(0, Math.floor((desiredQuantity - min) / step)) * step;
    const capped = Number.isFinite(max) ? Math.min(requested, min + Math.floor((max - min) / step) * step) : requested;
    quantity.value = String(Math.max(min, capped));
    window.history.replaceState(window.history.state, '', url);
    status.textContent = `${select.selectedOptions[0].textContent.trim()}. ${root.querySelector('[data-cl-variant-stock]').textContent.trim()}`;
    initCrestlanePurchaseObserver();
  } catch (error) {
    if (controller.signal.aborted || crestlaneVariantRequests.get(select) !== controller || !select.isConnected) return;
    select.value = root.dataset.clVariantId;
    status.classList.remove('cl-sr');
    status.textContent = status.dataset.error;
  } finally {
    if (crestlaneVariantRequests.get(select) === controller) {
      crestlaneVariantRequests.delete(select);
      form.dataset.clVariantLoading = 'false';
      if (form.dataset.clSubmitting !== 'true') form.removeAttribute('aria-busy');
      syncCrestlaneCartLimits(document.querySelector('[data-cl-cart-content]'));
      form.querySelectorAll('.cl-quantity input').forEach(syncCrestlaneQuantity);
    }
  }
}
document.addEventListener('click', function(event) {
  const stepper = event.target.closest('[data-cl-step]');
  if (stepper && !stepper.disabled) {
    const input = stepper.closest('.cl-quantity').querySelector('input');
    if (input.disabled) return;
    const min = Number(input.min || 0), max = input.max === '' ? Infinity : Number(input.max);
    const increment = Number(input.step || 1), value = Number(input.value) || min;
    input.value = Math.max(min, Math.min(max, value + Number(stepper.dataset.clStep) * increment));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  const four = event.target.closest('[data-cl-add-four]');
  if (four && !four.disabled) {
    const input = four.closest('form').querySelector('[name="quantity"]');
    input.value = 4;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  const thumb = event.target.closest('[data-cl-image]');
  if (thumb) {
    const main = document.getElementById('ProductMainImage');
    if (main) { main.removeAttribute('srcset'); main.src = thumb.dataset.clImage; main.alt = thumb.dataset.clAlt || ''; }
  }
});
document.addEventListener('change', function(event) {
  if (event.target.matches('.cl-quantity input')) syncCrestlaneQuantity(event.target);
  if (event.target.matches('[data-cl-autosubmit]')) event.target.form.requestSubmit();
  if (event.target.matches('[data-cl-variant]')) {
    updateCrestlaneVariant(event.target);
  }
});
document.addEventListener('input', function(event) {
  if (event.target.matches('.cl-quantity input')) syncCrestlaneQuantity(event.target);
});
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') document.querySelectorAll('.cl-menu[open]').forEach(menu => menu.removeAttribute('open'));
});
let crestlanePurchaseObserver;
function initCrestlanePurchaseObserver() {
  const sticky = document.querySelector('[data-cl-sticky-purchase]');
  const add = document.querySelector('#CrestlaneProductForm [name="add"]');
  crestlanePurchaseObserver?.disconnect();
  if (sticky && add && 'IntersectionObserver' in window) {
    crestlanePurchaseObserver = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, { threshold: 0.1 });
    crestlanePurchaseObserver.observe(add);
  }
}
let crestlaneHeaderCleanup;
let crestlaneHeaderElement;
function initCrestlaneHeader() {
  const shell = document.querySelector('[data-cl-header-shell]');
  if (!shell || shell === crestlaneHeaderElement) return;
  crestlaneHeaderCleanup?.();
  crestlaneHeaderElement = shell;
  const events = new AbortController();
  const options = { signal: events.signal };
  const header = shell.querySelector('[data-cl-header]');
  const menu = header.querySelector('.cl-menu');
  const opener = menu.querySelector('summary');
  const nav = menu.querySelector('[data-cl-drawer-nav]');
  const drawer = document.querySelector('[data-cl-nav-drawer]');
  const searchToggle = header.querySelector('[data-cl-search-toggle]');
  let fullHeight = header.offsetHeight;
  let frame = 0;
  const setOffset = () => document.documentElement.style.setProperty('--cl-sticky-offset', header.classList.contains('is-stuck') ? `${header.offsetHeight + 14}px` : '18px');
  function update() {
    frame = 0;
    const stuck = shell.dataset.sticky === 'true' && shell.getBoundingClientRect().top < -fullHeight;
    if (stuck && header.querySelector('crestlane-predictive-search')?.contains(document.activeElement)) {
      header.classList.add('is-search-open');
      searchToggle.setAttribute('aria-expanded', 'true');
    }
    shell.style.height = stuck ? `${fullHeight}px` : '';
    header.classList.toggle('is-stuck', stuck);
    if (!stuck) {
      header.classList.remove('is-search-open');
      searchToggle.setAttribute('aria-expanded', 'false');
    }
    setOffset();
  }
  function queueUpdate() { if (!frame) frame = requestAnimationFrame(update); }
  window.addEventListener('scroll', queueUpdate, { ...options, passive: true });
  window.addEventListener('resize', () => {
    header.classList.remove('is-stuck');
    shell.style.height = '';
    fullHeight = header.offsetHeight;
    update();
  }, options);
  const observer = new ResizeObserver(() => {
    if (!header.classList.contains('is-stuck')) fullHeight = header.offsetHeight;
    setOffset();
  });
  observer.observe(header);
  searchToggle.addEventListener('click', () => {
    const expanded = !header.classList.contains('is-search-open');
    header.classList.toggle('is-search-open', expanded);
    searchToggle.setAttribute('aria-expanded', String(expanded));
    if (expanded) header.querySelector('input[type="search"]').focus();
    else header.querySelector('crestlane-predictive-search')?.close?.();
    setOffset();
  }, options);
  if (drawer && typeof drawer.showModal === 'function') {
    opener.setAttribute('aria-expanded', 'false');
    opener.addEventListener('click', event => {
      event.preventDefault();
      drawer.querySelector('[data-cl-nav-body]').append(nav);
      drawer.showModal();
      document.documentElement.classList.add('cl-nav-open');
      opener.setAttribute('aria-expanded', 'true');
    }, options);
    drawer.querySelector('[data-cl-nav-close]').addEventListener('click', () => drawer.close(), options);
    drawer.addEventListener('click', event => {
      if (event.target !== drawer) return;
      const bounds = drawer.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) drawer.close();
    }, options);
    drawer.addEventListener('close', () => {
      menu.append(nav);
      document.documentElement.classList.remove('cl-nav-open');
      opener.setAttribute('aria-expanded', 'false');
      opener.focus({ preventScroll: true });
    }, options);
  }
  update();
  crestlaneHeaderCleanup = () => {
    events.abort(); observer.disconnect(); cancelAnimationFrame(frame);
    if (drawer?.open) drawer.close();
    document.documentElement.classList.remove('cl-nav-open');
  };
}
function initCrestlane() {
  initCrestlaneHeader();
  document.querySelectorAll('.cl-quantity input').forEach(syncCrestlaneQuantity);
  document.querySelectorAll('[data-cl-tag-filter], [data-cl-tag-remove] a').forEach(link => {
    if (link.dataset.clQueryPreserved) return;
    const url = new URL(link.href, window.location.origin);
    const current = new URLSearchParams(window.location.search);
    current.forEach((value, key) => {
      if ((key.startsWith('filter.') || key === 'sort_by' || key === 'preview_theme_id') && !url.searchParams.getAll(key).includes(value)) url.searchParams.append(key, value);
    });
    url.hash = 'CollectionGrid';
    link.href = url.toString();
    link.dataset.clQueryPreserved = 'true';
  });
  document.querySelectorAll('[data-cl-catalogue] .cl-filters a, [data-cl-catalogue] .cl-active-tags a, [data-cl-catalogue] .cl-pagination a').forEach(link => {
    const url = new URL(link.href, window.location.origin);
    url.hash = 'CollectionGrid';
    link.href = url.toString();
  });
  document.querySelectorAll('[data-cl-filter-form]').forEach(form => {
    if (form.dataset.clInitialized) return;
    form.dataset.clInitialized = 'true';
    // Turn old nation/rarity tag links into native filters so later selections use OR.
    if (form.dataset.clLegacyQuery) {
      const target = new URL(form.action, window.location.origin);
      const current = new URL(window.location.href);
      if (target.pathname !== current.pathname) {
        target.search = current.search;
        target.searchParams.delete('page');
        new URLSearchParams(form.dataset.clLegacyQuery.trim()).forEach((rawValue, rawKey) => {
          const key = rawKey.trim();
          const value = rawValue.trim();
          if (!target.searchParams.getAll(key).includes(value)) target.searchParams.append(key, value);
        });
        window.location.replace(target.toString());
        return;
      }
    }
    form.addEventListener('submit', () => {
      // Omit blank price bounds, preserving every selected value in each group.
      form.querySelectorAll('input[type="number"]').forEach(input => { input.disabled = input.value === ''; });
      const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (preview && !form.elements.namedItem('preview_theme_id')) {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = preview;
        form.append(input);
      }
    });
  });
  document.querySelectorAll('.cl-filter-panel').forEach(panel => {
    if (panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';
    const media = window.matchMedia('(max-width:800px)');
    panel.open = !media.matches;
    const dialog = panel.closest('.cl-collection-page')?.querySelector('[data-cl-filter-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const summary = panel.querySelector('summary'), filters = panel.querySelector('.cl-filters');
    summary.addEventListener('click', event => {
      if (!media.matches) return;
      event.preventDefault();
      dialog.querySelector('[data-cl-filter-body]').append(filters);
      dialog.showModal();
      document.documentElement.classList.add('cl-filter-open');
    });
    dialog.querySelectorAll('[data-cl-filter-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('close', () => {
      panel.append(filters);
      document.documentElement.classList.remove('cl-filter-open');
      summary.focus({ preventScroll: true });
    });
    media.addEventListener('change', () => {
      if (!panel.isConnected) return;
      if (dialog.open) dialog.close();
      panel.open = !media.matches;
    });
  });
  initCrestlanePurchaseObserver();
}
initCrestlane();
document.addEventListener('shopify:section:load', initCrestlane);
document.addEventListener('cl:products:loaded', initCrestlane);

